// extracted by mini-css-extract-plugin
export default {"subCell":"CellContent_subCell__+u+EW"};